import React, { useState } from 'react';


function BannerInicio({ img, texto }) {
  const [esLargo, setEsLargo] = useState(false); 
  useState(() => {
    if (texto.length > 45) return setEsLargo(true)
  })
  return (
    <div className='hidden md:relative md:flex md:w-full md:h-96'>
      <img src={img} alt='banner.jpg' className='w-full h-96 object-cover' />
      <div className={`absolute ${esLargo ? 'w-11/12' : ''} left-5 top-2/3 transform -translate-y-1/3 bg-black bg-opacity-65 text-Blanco p-4 rounded lg:p-6`}>
        <h1 className={`font-bold text-2xl ${esLargo ? 'lg:text-2xl' :'lg:text-3xl' }`}>{texto}</h1>
      </div>
      <div className='absolute inset-0 bg-black opacity-15'></div>
  </div>
  )
}

export default BannerInicio